import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Table from '@mui/material/Table';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';

import VpMediaTagsList from './VpMediaTagsList';
import VpMediaInfoMenu from './VpMediaInfoMenu';
import VpAttachmentInfoMenu from './VpAttachmentInfoMenu';
import { VpMediaIcon, VpCheckbox } from '../../';
import { useFetchMediaInsights, useMediaTableContext } from '../../../hooks';

const headCells = [
  { blank: true, id: 1 },
  { blank: true, id: 2 },
  { blank: true, id: 3 },
  {
    id: 'prompt',
    label: 'Prompt'
  },
  {
    id: 'type',
    label: 'Media Type'
  },
  {
    id: 'impressions',
    label: 'Impressions'
  },
  {
    id: 'plays',
    label: 'Plays'
  },
  {
    id: 'tags',
    label: 'Tags'
  },
  { blank: true, id: 4 }
];

// styles
const clickableStyles = {
  cursor: 'pointer'
};

export const VpMediaSubTable = withRouter(({ videos = [], attachments = [], onMediaRowClick }) => {
  const { onMediaCheck, getIsMediaSelected } = useMediaTableContext();

  const mediaIds = videos?.map((video) => video?.mediaId);
  const { data, isLoading } = useFetchMediaInsights(mediaIds);

  const onCheckboxClick = (e, media) => {
    e.stopPropagation();
    onMediaCheck(media);
  };
  const getImpressions = (mediaId) => data?.[mediaId]?.impressions || '';
  const getPlays = (mediaId) => data?.[mediaId]?.plays || '';

  return (
    <Table>
      <TableHead>
        <TableRow>
          {headCells.map((cell) =>
            cell.blank ? (
              <TableCell key={cell.id} padding="checkbox"></TableCell>
            ) : (
              <TableCell key={cell.id}>{cell.label}</TableCell>
            )
          )}
        </TableRow>
      </TableHead>
      <TableBody>
        {videos.map((media) => (
          <TableRow
            hover
            sx={clickableStyles}
            onClick={() => onMediaRowClick(media?.mediaId)}
            key={media?.mediaId}
          >
            <TableCell padding="checkbox"></TableCell>
            <TableCell padding="checkbox">
              <VpCheckbox
                onClick={(e) => onCheckboxClick(e, media)}
                checked={getIsMediaSelected(media?.mediaId)}
              />
            </TableCell>
            <TableCell>
              <VpMediaIcon media={media} />
            </TableCell>
            <TableCell>{media?.label}</TableCell>
            <TableCell>
              <Chip label="video" />
            </TableCell>
            <TableCell>
              {isLoading ? <CircularProgress size={24} /> : getImpressions(media?.mediaId)}
            </TableCell>
            <TableCell>
              {isLoading ? <CircularProgress size={24} /> : getPlays(media?.mediaId)}
            </TableCell>
            <TableCell>
              <VpMediaTagsList tags={media?.tags} />
            </TableCell>
            <TableCell>
              <VpMediaInfoMenu disableCustomizeThumbnail media={media} />
            </TableCell>
          </TableRow>
        ))}
        {attachments.map((media) => (
          <TableRow
            hover
            sx={clickableStyles}
            onClick={() => onMediaRowClick(media?.attachmentId)}
            key={media?.attachmentId}
          >
            <TableCell padding="checkbox"></TableCell>
            <TableCell padding="checkbox">
              <VpCheckbox
                onClick={(e) => onCheckboxClick(e, media)}
                checked={getIsMediaSelected(media?.attachmentId)}
              />
            </TableCell>
            <TableCell>
              <VpMediaIcon media={media} />
            </TableCell>
            <TableCell>{media.label}</TableCell>
            <TableCell>
              <Chip label={media.contentType} />
            </TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell>
              <VpAttachmentInfoMenu media={media} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
});

VpMediaSubTable.propTypes = {
  videos: PropTypes.arrayOf(PropTypes.object),
  attachments: PropTypes.arrayOf(PropTypes.object)
};

export default VpMediaSubTable;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpMediaTable/VpMediaSubTable.jsx